import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { LabelMedium } from "Cobalt/BodyText";
import BodyText from "Common/BodyText";
import { Card, CardHeader, CardSection } from "Common/Card/";
import { Row, Col } from "Common/Grid";
import { Span } from "Common/HTML";

import PlanTermRange from "./planAnalysis/PlanTermRange";
import RangeBar from "./planAnalysis/RangeBar";

const Legend = (props) => (
  <div {...props}>
    <Span mr={3}>Lower</Span>
    <div style={{ display: "inline-block", width: 250 }}>
      <RangeBar color="green" />
      <RangeBar color="lightgreen" />
      <RangeBar color="yellow" />
      <RangeBar color="lightorange" />
      <RangeBar color="orange" />
    </div>
    <Span ml={3}>Higher</Span>
  </div>
);

export default function PlanAnalysis({ planRangeProps, plan, totalItems }) {
  return (
    <Card theme="flat" className={classnames("section-holder")} id="planAnalysis" p={0}>
      <CardHeader className="clearfix">
        <BodyText componentClass="div" size="ns-twelve" className="float-right" style={{ textAlign: "right", fontWeight: "normal" }}>
          <Legend />
          (compared to {totalItems} plans in your area)
        </BodyText>
        Plan Analysis
      </CardHeader>
      <CardSection>
        <BodyText>
          <Row>
            <Col md={6}>
              <LabelMedium>Average Employee Cost Per Month</LabelMedium>
              <PlanTermRange min={planRangeProps.minPremium} max={planRangeProps.maxPremium} value={plan.average_monthly_premium} />

              <hr />
              <LabelMedium>Deductible</LabelMedium>
              <PlanTermRange min={planRangeProps.minDeductible} max={planRangeProps.maxDeductible} value={plan.deductible} />

              <hr />
              <LabelMedium>Doctor Visits</LabelMedium>
              <PlanTermRange min={planRangeProps.minDoctorsCost} max={planRangeProps.maxDoctorsCost} value={plan.estimated_costs.pcp_visit} />
            </Col>
            <Col md={6}>
              <LabelMedium>Generic Drug Cost</LabelMedium>
              <PlanTermRange min={planRangeProps.minGenericDrugCost} max={planRangeProps.maxGenericDrugCost} value={plan.estimated_costs.generic_drugs} />

              <hr />
              <LabelMedium>Emergency Room Visit</LabelMedium>
              <PlanTermRange
                min={planRangeProps.minEmergencyRoomVisitCost}
                max={planRangeProps.maxEmergencyRoomVisitCost}
                value={plan.estimated_costs.emergency_room}
              />

              <hr />
              <LabelMedium>Hospital Visit</LabelMedium>
              <PlanTermRange
                min={planRangeProps.minHospitalizationCost}
                max={planRangeProps.maxHospitalizationCost}
                value={plan.estimated_costs.hospitalization}
              />
            </Col>
          </Row>
        </BodyText>
      </CardSection>
    </Card>
  );
}

PlanAnalysis.propTypes = {
  plan: PropTypes.object,
  planRangeProps: PropTypes.object,
  totalItems: PropTypes.number,
};
